import React, { useState } from 'react';
import { Drawer, DrawerHeader, DrawerBody, Typography, DrawerFooter, LoadingButton, Button, Alert, } from '@one-thd/sui-atomic-components';
import { GetSORISCancelAPI } from '../../../../api/oms/order-details';
import CancelLineitemsView from './CancelLineItemsView';
import { TriggerCancelSorisOnAbandonAnalytics, TriggerCancelSorisOnClickCancelAnalytics, TriggerCancelSorisOnErrorAnalytics, } from '../../../../utils/analytics';
import { TrackEditDeliveryAddressAnalytics } from '../../../../utils/edit-delivery-address/analytics';
export var ERROR_MESSAGE = 'There was a temporary technical error. Please try again shortly. If the issue persists, please call Customer Support at 1-800-430-3376.';
var SUCCESS_MESSAGE = "We've cancelled your return. You can start a new return for items still within their open return window.";
var CancelConfirmationDrawer = function (_a) {
    var displayDrawer = _a.displayDrawer, closeDrawer = _a.closeDrawer, lineItems = _a.lineItems, sorisReturnCancelRequest = _a.sorisReturnCancelRequest;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    var _d = useState(), apiResponse = _d[0], setAPIResponse = _d[1];
    // Refreshing the page so the updated order details can reflect once cancel is successful
    var navigateToUpdatedOrderDetails = function () { return window.location.reload(); };
    var onClick = function () {
        if (apiResponse) {
            TrackEditDeliveryAddressAnalytics('purchase history: order details: edit delivery address order details button', 'button submission');
            navigateToUpdatedOrderDetails();
            return;
        }
        handleCancelClick();
    };
    var onClose = function () {
        // We dont want to close the drawer if the request is still loading
        if (loading)
            return;
        // If the user tries to navigate away from the drawer after a successful cancel we want to refresh the page
        if (apiResponse)
            navigateToUpdatedOrderDetails();
        // Want to capture this analytics if user did not cancel the return and closed the drawer
        TriggerCancelSorisOnAbandonAnalytics();
        // Resetting states when the drawer is closed
        setLoading(false);
        setError(false);
        setAPIResponse(undefined);
        closeDrawer();
    };
    var handleCancelClick = function () {
        setLoading(true);
        setError(false);
        TriggerCancelSorisOnClickCancelAnalytics();
        return GetSORISCancelAPI(sorisReturnCancelRequest)
            .then(function (response) {
            var _a;
            if (!((_a = response.data) === null || _a === void 0 ? void 0 : _a.orderId)) {
                throw new Error('No orderId or tracking number found');
            }
            setAPIResponse(response.data);
        })
            .catch(function () {
            TriggerCancelSorisOnErrorAnalytics();
            setError(true);
        })
            .finally(function () { return setLoading(false); });
    };
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-full sui-gap-4 sui-w-96" },
        React.createElement(Drawer, { open: displayDrawer, onClose: onClose, position: "right", className: "drawer-z-index-fix" },
            React.createElement(DrawerHeader, { title: "Cancel This Return?", onClose: onClose }),
            React.createElement(DrawerBody, { style: { 'padding-bottom': '0' } },
                error && (React.createElement(Alert, { status: "error", size: "large" }, ERROR_MESSAGE)),
                apiResponse && (React.createElement(Alert, { status: "success", size: "large" }, SUCCESS_MESSAGE)),
                React.createElement(Typography, { variant: "body-base", style: { marginBottom: '2.4rem' } }, "Review the items below that you want to keep. You can still start a return for these items within their return window."),
                React.createElement(CancelLineitemsView, { lineItems: lineItems })),
            React.createElement(DrawerFooter, { className: "sui-bg-primary sui-p-4 sui-relative sui-bottom-0 sui-sticky sui-shadow-sm" },
                React.createElement("div", { className: "sui-flex sui-flex-col sui-min-w-full sui-gap-4" },
                    React.createElement(LoadingButton, { loading: loading, fullWidth: true, style: { width: '100%' }, onClick: onClick }, apiResponse
                        ? 'Back to Order Details'
                        : 'Yes, Cancel This Return'),
                    !apiResponse && (React.createElement(Button, { fullWidth: true, style: { width: '100%' }, variant: "secondary", onClick: onClose }, "No")))))));
};
export default CancelConfirmationDrawer;
